
import { defineComponent } from "vue";
import HomeTable from "@/components/organisms/HomeTable/HomeTable.vue";
import { RouteLocationRaw } from "vue-router";

export default defineComponent({
  name: "HomeView",
  components: {
    HomeTable,
  },
  methods: {
    goTo(value: RouteLocationRaw) {
      return this.$router.push(value);
    },
  },
});
